const PRIVATE_KEY_MARKERS = [
	'/ozoners/',
	'/loan/',
	'/financialForm/',
	'/repossessions/',
] as const;

const VEHICLE_EVIDENCE_DOCUMENT_KEY = /^uploads\/[^/]+_[^/]+\//;

export const extractS3KeyFromReference = (reference: string): string => {
	const trimmed = reference.trim();

	if (trimmed.startsWith('uploads/') || trimmed.startsWith('public/')) {
		return trimmed;
	}

	const amazonMarker = '.amazonaws.com/';
	if (trimmed.includes(amazonMarker)) {
		return trimmed.slice(trimmed.indexOf(amazonMarker) + amazonMarker.length);
	}

	return trimmed;
};

export const resolveStorageKey = (file?: {
	url?: string;
	path?: string;
}): string | null => {
	if (file?.path?.trim()) return file.path.trim();
	if (file?.url?.trim()) return extractS3KeyFromReference(file.url);
	return null;
};

export const isPrivateStorageKey = (key?: string | null): boolean => {
	if (!key?.trim()) return false;

	const normalized = key.trim();

	if (PRIVATE_KEY_MARKERS.some((marker) => normalized.includes(marker))) {
		return true;
	}

	if (VEHICLE_EVIDENCE_DOCUMENT_KEY.test(normalized)) {
		return true;
	}

	return false;
};

export const isPrivateStorageFile = (file?: {
	url?: string;
	path?: string;
}): boolean => isPrivateStorageKey(resolveStorageKey(file));
